import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
  type FC,
  type JSX,
  type ReactNode,
} from 'react';

interface SiderContextInterface {
  isSiderCollapsed: boolean;
  setIsSiderCollapsed: Dispatch<SetStateAction<boolean>>;
}

const defaultSiderContext: SiderContextInterface = {
  isSiderCollapsed: false,
  setIsSiderCollapsed: () => {},
};

const SiderContext = createContext<SiderContextInterface>(defaultSiderContext);

interface SiderProviderProps {
  children: ReactNode;
}

export const SiderProvider: FC<SiderProviderProps> = ({ children }): JSX.Element => {
  const [isSiderCollapsed, setIsSiderCollapsed] = useState(false);

  const value: SiderContextInterface = {
    isSiderCollapsed,
    setIsSiderCollapsed,
  };

  return <SiderContext.Provider value={Object.freeze(value)}>{children}</SiderContext.Provider>;
};

export const useSiderContext = (): SiderContextInterface => useContext(SiderContext);
